import template from './reportsList.template.html';

export default {
  template,
  bindings: {
    reports: '<',
    onEdit: '&',
    onClick: '&',
    onChange: '&',
    onReady: '&'
  },
  controller: class controller {
    constructor($rootScope, $filter, $mdMedia, listServiceNew) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.natural = $rootScope.natural;
      ctrl.list = new listServiceNew.List();
      ctrl.list.clear();

      ctrl.initialize = () => {
        ctrl.reports = ctrl.reports || [];
        ctrl.list.setData(
          $filter('stStartingLetter')(ctrl.reports, ctrl.list.getGroupingByFirstLetter())
        );
        ctrl.onReady({ list: ctrl.list });
      };

      ctrl.edit = ($event, data) => {
        ctrl.onEdit({ event: $event, data });
      };

      ctrl.click = ($event, data, isList) => {
        ctrl.onClick({ event: $event, data, isList });
      };

      ctrl.select = (data) => {
        const isSelected = ctrl.list.setSelected(data);
        ctrl.onChange({ list: ctrl.list, data, isSelected });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onChanges = (changes) => {
        if (changes.reports && changes.reports.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
